var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15794_139780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 15V17H5V15H3ZM15 19V21H17V19H15ZM19 3L5 3C3.9 3 3 3.9 3 5V9H5V5L19 5V9H21V5C21 3.9 20.1 3 19 3ZM21 19H19V21C20.1 21 21 20.1 21 19ZM1 11L1 13L23 13L23 11L1 11ZM7 19V21H9V19L7 19ZM19 15L19 17H21V15H19ZM11 19V21H13V19H11ZM3 19C3 20.1 3.9 21 5 21V19H3Z",
    fill: "#303238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15794_139780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 1 -1 0 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalFlip);
export default __webpack_public_path__ + "static/media/vertical-flip.10dac8a793cfd984d9b8deace0aedb87.svg";
export { ForwardRef as ReactComponent };